import { useMemo } from 'react';

import { apiRoutes } from '@/config/apiRoutes';

import type { ConsumerViewParams, ConsumerUrls } from '../types/consumer.types';

import { buildUrlParams } from '../utils/urlBuilder';

export const useConsumerUrls = (params: ConsumerViewParams | null): ConsumerUrls | null =>
  useMemo((): ConsumerUrls | null => {
    if (!params) return null;

    const tableParams = buildUrlParams(params);
    const chartParams = buildUrlParams(params);
    const exportParams = buildUrlParams(params);

    return {
      tableUrl: `${apiRoutes.base}${apiRoutes.consumption.base}?${tableParams}`,
      chartUrl: `${apiRoutes.base}${apiRoutes.consumption.base}${apiRoutes.consumption.chart}?${chartParams}`,
      exportUrl: `${apiRoutes.base}${apiRoutes.consumption.base}${apiRoutes.consumption.export}?${exportParams}`,
    };
  }, [params]);
